module.exports = __webpack_public_path__ + "static/90-388e166d69cbc56b00c59769cd9f990c.png";